interface Props {
  search: string;
}

export const parseQuerystring = ({ search }: Props): string => {
  try {
    const searchString =
      typeof window === 'undefined' ? '' : window?.location?.search || '';
    const query = new URLSearchParams(searchString);

    return query.get(`${search}`) || '';
  } catch (err) {
    return '';
  }
};
